import { call, put, takeLatest, all } from 'redux-saga/effects';

import { customerId } from 'common/helpers/tokenHelper';
import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import { listAllocations } from './api';
import {
  RESET_ALLOCATION_ISFETCHING,
  LIST_ALLOCATIONS_REQUEST,
  LIST_ALLOCATIONS_SUCCESS,
  ALLOCATION_LIST_REQUESTING
} from './constants';

function* list() {
  try {
    yield call(removeAPIError);
    yield put({ type: ALLOCATION_LIST_REQUESTING });
    const response = yield call(listAllocations, customerId());
    yield put({
      type: LIST_ALLOCATIONS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_ALLOCATION_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* watchList() {
  yield takeLatest(LIST_ALLOCATIONS_REQUEST, list);
}

export default function* allocationSagas() {
  yield all([watchList()]);
}
